import { gql } from '@apollo/client';

const CLINIC_TICKET_FRAGMENT = gql`
  fragment ClinicTicketFragment on ClinicTicket {
    id
    ticketId
    requestedBy {
      id
      firstName
      lastName
    }
    status
    message
    replyTo
    resolution
    category
    issues
    contents {
      study {
        id
        friendlyId
      }
      studyType {
        old
        new
      }
      deviceId
      deviceIssues
    }
    facility {
      id
      name
    }
    participants {
      id
      firstName
      lastName
    }
    lastSeenTicketComment {
      createdBy {
        id
      }
    }
  }
`;

export default CLINIC_TICKET_FRAGMENT;
